import React from 'react';
import PropTypes from 'prop-types';
import Hotkeys from 'react-hot-keys';

class ShortcutOpen extends React.Component {
  constructor() {
    super();
    this.state = {
      enableHotKeys: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.favorites.length !== this.props.favorites.length) {
      this.handleEnableHotKeys(false);
    }

    if (this.state.enableHotKeys !== prevState.enableHotKeys && !this.state.enableHotKeys) {
      this.handleEnableHotKeys(true);
    }
  }

  handleEnableHotKeys = (state) => {
    this.setState({
      enableHotKeys: state,
    });
  };

  onKeyUp(keyName) {
    const dashboardNumber = parseInt(keyName.substr(keyName.length - 1), 10);
    this.props.history.push(`/dashboard/view/${this.props.favorites[dashboardNumber - 1].id}`);
  }

  createHotkeysShortcutString = () => {
    const favorites = this.props.favorites || [];
    const hotKeysString = [];
    for (let i = 0; i < favorites.length; i++) {
      hotKeysString.push(`alt+${i + 1}`);
    }
    return hotKeysString.join(',');
  };

  render() {
    return (
      <>
        {this.state.enableHotKeys && (
          <Hotkeys keyName={this.createHotkeysShortcutString()} onKeyUp={this.onKeyUp.bind(this)} />
        )}
      </>
    );
  }
}

ShortcutOpen.propTypes = {
  openDashboard: PropTypes.func,
  favorites: PropTypes.arrayOf(PropTypes.any),
  history: PropTypes.objectOf(PropTypes.any),
};

ShortcutOpen.defaultProps = {
  openDashboard: undefined,
  favorites: [],
  history: {},
};

export default ShortcutOpen;
